import {Component} from 'react';

export default class Body extends Component {
	render() {
		const { body } = this.props;
		return body
	}
}